<template>
  <v-container>
    <h1 class="mb-3">Contact Us</h1>

    <v-form v-model="valid" ref="form" @submit.prevent="submit">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            :disabled="!!currentUser"
            v-model="formData.name"
            :rules="nameRules"
            :counter="20"
            label="Name"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            :disabled="!!currentUser"
            v-model="formData.email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="formData.subject"
            :rules="subjectRules"
            label="Message Subject"
            :items="msgTypes"
            required
          />
        </v-col>
        <v-col cols="12">
          <v-textarea v-model="formData.message" :rules="messageRules" label="Message" required />
        </v-col>
      </v-row>
      <v-btn
        :disabled="!valid"
        :loading="loading"
        class="d-block mx-auto"
        color="primary"
        type="submit"
      >Submit</v-btn>
    </v-form>
    <v-snackbar v-model="snackbar">Your message was sent</v-snackbar>
  </v-container>
</template>
<script>
import { db } from "@/firebase";
import { mapState } from "vuex";
export default {
  computed: mapState(["currentUser"]),
  data: () => ({
    snackbar: false,
    loading: false,
    valid: false,
    formData: {
      name: "",
      email: "",
      subject: null,
      message: ""
    },
    msgTypes: [
      "Support request",
      "Feature request",
      "Feedback",
      "Bug report",
      "Inquiry",
      "Other"
    ],
    nameRules: [
      v => !!v || "Name is required",
      v => v.length <= 20 || "Name must be less than 20 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    subjectRules: [v => !!v || "Subject is required"],
    messageRules: [v => !!v || "Message is required"]
  }),
  methods: {
    submit() {
      this.loading = true;
      db.collection("contactform")
        .add(this.formData)
        .then(() => {
          this.snackbar = true;
          this.loading = false;
          this.formData.subject = null;
          this.formData.message = "";
          this.$refs.form.resetValidation();
        });
    }
  },
  created() {
    if (this.currentUser)
      this.formData = {
        name: this.currentUser.displayName,
        email: this.currentUser.email
      };
  }
};
</script>